import { Fragment } from 'react';
import { FieldErrors } from 'react-hook-form';

import classNames from 'classnames';

import { useSerializeDraftUnitMessage } from '../../hooks';
import { setMessagesToGQLLineContent } from '../../utils';
import { LineMessageBlock } from '../line-message-form';

import {
  LineMessagePreviewImages,
  LineMessagePreviewPlainText,
  LineMessagePreviewRichMessage,
  LineMessagePreviewButton,
} from './components';
import { Option } from './types';

export type LineMessagePreviewProps = {
  onChange: (props: { updatedDraftContent?: string; messages: LineMessageBlock[] }) => void;
  onAddLineMessage: () => Promise<string | undefined>;
  postbackOptions?: Option[];
  className?: string;
  messages: LineMessageBlock[];
  title: string;
  errors?: FieldErrors<LineMessageBlock>[];
};

export const LineMessagePreview = ({
  className,
  messages,
  onChange,
  onAddLineMessage,
  postbackOptions,
  title,
  errors,
}: LineMessagePreviewProps) => {
  const { serializeDraftUnitMessage, isSerializing } = useSerializeDraftUnitMessage({
    hideToast: true,
  });

  return (
    <div className={classNames('flex flex-col gap-y-4', className)}>
      {messages.map((message, index) => {
        const handleChange = async (updatedMessage: LineMessageBlock) => {
          const newMessages = [...messages];
          newMessages[index] = updatedMessage;

          const updatedDraftContent = await serializeDraftUnitMessage({
            name: title ?? '',
            messageItems: setMessagesToGQLLineContent(newMessages),
          });

          onChange?.({ updatedDraftContent, messages: newMessages });
        };

        return (
          <Fragment key={`${message.type}-${index}`}>
            {message.type === 'PLAIN_TEXT' && <LineMessagePreviewPlainText {...message} />}
            {message.type === 'RICH' && <LineMessagePreviewRichMessage {...message} />}
            {message.type === 'IMAGES' && <LineMessagePreviewImages {...message} />}
            {message.type === 'BUTTON' && (
              <LineMessagePreviewButton
                {...message}
                loading={isSerializing}
                postbackOptions={postbackOptions}
                onChange={handleChange}
                onAddLineMessage={onAddLineMessage}
                error={errors?.[index]}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
